var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{attrs:{"autoplay":"","loop":""}},[_c('source',{attrs:{"src":this.getVideo,"type":"video/mp4"}}),_vm._v(" This browser does not support the video tag. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }